<audio #twilioRingtone loop preload="auto">     
    <!-- <source src="../../src/assets/audio/ringtone.mp3" type="audio/mpeg"> -->
    <!-- <source src="/31904-CCC-WEB-UI/src/assets/audio/ringtone-trimmed.mp3" type="audio/mpeg"> -->
    <source src="../../../../assets/audio/ringtone-trimmed.mp3" type="audio/mpeg">
</audio>
<div class="modal-body">
    <div>
        <!-- *ngIf = "timeout == false" -->
        <div *ngIf = "timeout == false" class="col-12 incoming-call-wrapper">
            <div class="col title">
                <p>{{'elevator_call_details.incomingCall' | localize}}</p>
            </div>
            <div class="col">
                <div class="elevator-icon pulses">
                    <div class="icon-bg"><span class="material-symbols-outlined">
                            <mat-icon>phonecallback</mat-icon>
                        </span></div>
                </div>

            </div>
            <div class="col caller-name">
               <p>{{_data.displayElevatorId}}</p>
            </div>
            <div class="col caller-name">
                <p class="col title">{{'elevator_call_details.buildingName' | localize}}{{':'}}{{_data.buildingName}} </p>                               
            </div>
            <div class="col caller-name">
                <p class="col title">{{'elevator_call_details.buildingAdd' | localize}}{{''}}{{_data.buildingAddress}}</p>                               
            </div>
            <div class="col caller-name">
                <p class="caller-img-title">{{'elevator_call_details.branchName'  | localize}}{{':'}}{{_data.branchName}}</p>                            
            </div>
            <div class="col time-slot">
                <p class="time-remain">{{'elevator_call_details.timeLeft'  | localize}}</p>
                <p class="time-numbers">
                    <span>{{counter}}</span>
                </p>
                <p class="sec">{{'sec'  | localize}}</p>
            </div>
            <div class="col answer-call d-inline-flex">
                <div class="col answer-call-wrapper">
                    <p class="answer-call-icon" (click)="acceptTheCall()"><mat-icon>phone</mat-icon></p>
                    <p class="caller-img-title">{{'elevator_call_details.answer'  | localize}}</p>
                </div>
                <div class="col ms-5" [hidden]="silenceCall">
                    <p class="notification-call-icon" (click)="silenceTheCall()">
                        <mat-icon>notifications_active</mat-icon></p>
                    <p class="caller-img-title">{{'Silence'  | localize}}</p>
                </div>
                <div class="col ms-5" [hidden]="!silenceCall">
                    <p class="notification-call-icon"><mat-icon>notifications_off</mat-icon></p>
                    <p class="caller-img-title">{{'Silenced'  | localize}}</p>
                </div>
            </div>
            <div class="col-12 caller-footer">
                <p class="caller-img-title">{{'dashboard.shutDownReasonTbHeader' | localize}}</p>
                <p>{{_data.failurCode}}</p>
            </div>
        </div>
        <div [hidden]="!timeout" class="col-12 incoming-call-wrapper">
            <div class="col title">
                <p>{{'elevator_call_details.missedCallMsg'  | localize}} : {{_data.displayElevatorId}}</p>
                <hr>
            </div>
            <div class="col title">
                
               <p> {{'elevator_call_details.urStatusSetto'  | localize}} : {{selectedAgentStatus.selectedStatus}} </p>
                    
            </div>
            <div>
                <p>{{'elevator_call_details.change2ReceiveCall'  | localize}}</p>
            </div>
            <div class="timeout-status">
                <span>{{'elevator_call_details.status'  | localize}}</span>
                <span>
                    <select [(ngModel)]="selectedAgentStatus.selectedStatus">
                        <option *ngIf="selectedAgentStatus.selectedStatus === undefined" [value]="undefined" [selected]=true>{{selectedAgentStatus.selectedStatus=== undefined? 'Loading...': ''}}</option>
                        <ng-container  *ngFor="let statusVal of userStatus">
                            <option  *ngIf="selectedAgentStatus.selectedStatus !==undefined" [hidden]="(statusVal.sId == '' ||  (statusVal.display == undefined || statusVal.display == false) )" [value]="statusVal.status" >
                                {{statusVal.status  | localize}}
                            </option>                            
                        </ng-container>
                    </select>
                </span>
            </div>
            <div mat-dialog-actions align="end">
                <button  mat-raised-button (click) = "changeAgentStatus(selectedAgentStatus.selectedStatus, null, true)"
                    color="primary">{{ 'ok'  | localize}}</button>
            </div>
        </div>
    </div>
</div>
